import React from "react";
import { ArrowRight, Building2, UserRound, MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../data/mock";

const Hero = ({ onCompany, onWorker }) => {
  const { t } = useLanguage();

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Warehouse team"
          className="h-full w-full object-cover grayscale animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black" />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="relative z-10 container-px mx-auto max-w-7xl pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="animate-fade-up mb-5 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-1.5 backdrop-blur-md">
            <MapPin className="h-3.5 w-3.5 text-white/80" />
            <span className="text-xs font-medium tracking-wide text-white/85">{t.hero.localBadge}</span>
          </div>
          <p className="animate-fade-up text-xs sm:text-sm font-medium tracking-[0.25em] text-white/65 mb-6">
            {t.hero.eyebrow}
          </p>
          <h1
            className="animate-fade-up font-display text-5xl sm:text-6xl lg:text-7xl font-bold uppercase leading-[0.98] tracking-tight text-white"
            style={{ animationDelay: "0.1s" }}
          >
            {t.hero.title}
          </h1>
          <p
            className="animate-fade-up mt-6 max-w-xl text-base sm:text-lg text-white/70 leading-relaxed"
            style={{ animationDelay: "0.2s" }}
          >
            {t.hero.subtitle}
          </p>

          <div
            className="animate-fade-up mt-9 flex flex-col sm:flex-row gap-4"
            style={{ animationDelay: "0.3s" }}
          >
            <button onClick={onCompany} className="glass-btn-solid glass-btn px-7 py-3.5 text-sm font-semibold">
              <Building2 className="h-4 w-4" />
              {t.hero.ctaCompany}
              <ArrowRight className="h-4 w-4" />
            </button>
            <button onClick={onWorker} className="glass-btn px-7 py-3.5 text-sm font-semibold">
              <UserRound className="h-4 w-4" />
              {t.hero.ctaWorker}
            </button>
          </div>
        </div>
      </div>

      {/* bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black to-transparent" />
    </section>
  );
};

export default Hero;
